import React, { useRef, useEffect } from 'react'
import Chart, { ChartData } from 'chart.js/auto'
import styled from 'styled-components'
import { SimulationsResponse } from '../../../types/API'

interface ExecutionsSucceededChartProps {
  data: SimulationsResponse
}

const ExecutionsSucceededChart: React.FC<ExecutionsSucceededChartProps> = ({ data }) => {
  const lineData: Record<string, number> = {}
  let totalizer = 0

  for (const [date, { executionSucceeded }] of Object.entries(data)) {
    if (lineData[date]) {
      lineData[date] += executionSucceeded
    } else {
      lineData[date] = executionSucceeded
    }
    if (executionSucceeded) {
      totalizer += executionSucceeded
    }
  }

  const processData = () => {
    const allDateLabels = Object.keys(data)
    allDateLabels.sort()
    return { dateLabels: allDateLabels }
  }

  const { dateLabels } = processData()

  const chartData: ChartData<'line', number[], string> = {
    labels: dateLabels,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Successful Executions',
        yAxisID: 'tasks-y-axis',
        data: Object.values(lineData),
        borderColor: 'rgb(107,171,82)',
        backgroundColor: 'rgb(68,121,47)',
        pointBackgroundColor: 'rgb(107,171,82)',
        tension: 0.8,
        pointRadius: 7,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: 'rgb(107,171,82)',
        pointHoverBorderColor: 'rgb(107,171,82)',
      },
    ],
  }

  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  const createChart = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d')
      if (ctx) {
        chartRef.current = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              'tasks-y-axis': {
                beginAtZero: true,
              },
            },
          },
        })
      }
    }
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy()
    }
  }

  useEffect(() => {
    createChart()

    return () => {
      destroyChart()
    }
  }, [data])

  return (
    <>
      <h1>Succeeded Executions {totalizer > 0 && <Tot>Total: {totalizer}</Tot>}</h1>
      <div>
        <canvas ref={canvasRef} />
      </div>
    </>
  )
}

const Tot = styled.p`
  font-size: 14px;
  display: inline-flex;
  background: rgb(107, 171, 82);
  padding: 5px 10px;
  border-radius: 22px;
  margin-left: 18px;
`

export default ExecutionsSucceededChart
